import { readEnv } from "./readEnv.js";


export const deploymentEnvs = ["development", "staging", "prod"] as const;
export type DeploymentEnv = typeof deploymentEnvs[number];


/**
 * Returns "development", "staging", or "prod".
 */
export function getEnvironment(): DeploymentEnv {
    const env = readEnv("DEPLOYMENT_ENV");
    if (env !== "development" && env !== "staging" && env !== "prod")
        throw new Error(`Invalid DEPLOYMENT_ENV: ${env}`);

    return env;
}
